import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface NSMembershipState {
  loading: boolean;
  isNSMember: boolean;
  userId: string | null;
}

export function useIsNSMember(): NSMembershipState {
  const [state, setState] = useState<NSMembershipState>({
    loading: true,
    isNSMember: false,
    userId: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        if (!cancelled) setState({ loading: false, isNSMember: false, userId: null });
        return;
      }
      const { data } = await supabase
        .from("profiles")
        .select("ns_member")
        .eq("id", user.id)
        .maybeSingle();
      if (cancelled) return;
      setState({
        loading: false,
        isNSMember: !!(data as { ns_member?: boolean } | null)?.ns_member,
        userId: user.id,
      });
    })();
    return () => { cancelled = true; };
  }, []);

  return state;
}
